import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=0207cb00&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=0207cb00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0207cb00",
  null
  
)

export default component.exports